<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Equipo" />

    <CreateTeam />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreateTeam from "@/components/Pages/Admin/Teams/view.vue";

export default defineComponent({
  name: "CreateTeamPage",
  components: {
    PageTitle,
    CreateTeam,
  },
});
</script>
